<template>
    <div>
        <b-card v-show="mostrarTabela" no-body>
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>CONVÊNIOS</span>
                </h4>
                <app-tabela
                    :itens="convenios"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false"
                >
                    <template slot="botoes">
                        <b-button-group class="float-right">
                            <b-button
                                variant="success"
                                @obterConvenios="obterConvenios()"
                                @click="NovoConvenio()"
                                v-if="$temAcessoView('CONV-01')"
                                >Novo Convênio</b-button
                            >
                        </b-button-group>
                    </template>
                    <template slot="nuValorConvenio" slot-scope="data">
                        <span class="text-nowrap">{{
                            data.nuValorConvenio | currency
                        }}</span>
                    </template>
                    <template slot="vigencia" slot-scope="data">
                        {{
                            data.dtInicioVigencia
                                ? $moment(data.dtInicioVigencia).format(
                                      'DD/MM/YYYY'
                                  )
                                : ''
                        }}
                        <span v-if="data.dtInicioVigencia">a</span>
                        {{
                            data.dtFimVigencia
                                ? $moment(data.dtFimVigencia).format(
                                      'DD/MM/YYYY'
                                  )
                                : ''
                        }}
                    </template>
                    <template slot="situacaoConvenio" slot-scope="data">
                        <app-status
                            :status="data.situacaoConvenio.toUpperCase()"
                        ></app-status>
                    </template>

                    <template slot="descricaoStatusRM" slot-scope="data">
                        <app-status
                            :status="data.descricaoStatusRM.toUpperCase()"
                        ></app-status>
                    </template>

                    <template
                        slot="descricaoTipoAplicacaoRecurso"
                        slot-scope="data"
                    >
                        <app-status
                            :status="
                                data.descricaoTipoAplicacaoRecurso.toUpperCase()
                            "
                        ></app-status>
                    </template>

                    <template slot="acoes" slot-scope="data">
                        <span
                            class="text-primary mr-1"
                            v-if="$temAcessoView('CONV-03')"
                        >
                            <i
                                class="fa fa-info-circle fa-lg icon-button"
                                title="Detalhar"
                                @click.stop="detalharConvenio(data.idConvenio)"
                            ></i>
                        </span>
                        <span
                            class="text-primary mr-1"
                            v-if="
                                $temAcessoView('CONV-02') &&
                                data.idSituacaoConvenio != 9
                            "
                        >
                            <i
                                class="fa fa-pencil fa-lg icon-button"
                                title="Editar"
                                @click.stop="editarConvenio(data.idConvenio)"
                            ></i>
                        </span>
                        <span
                            class="text-danger mr-1"
                            v-if="
                                $temAcessoView('CONV-05') &&
                                data.idSituacaoConvenio != 9
                            "
                        >
                            <i
                                class="fa fa-stop-circle-o fa-lg icon-button"
                                title="Encerrar Convênio"
                                @click.stop="confirmarEncerrarConvenio(data)"
                            ></i>
                        </span>
                        <span
                            class="text-primary"
                            v-if="
                                $temAcessoView('CONV-04') &&
                                data.statusIntegracaoRM != 'S' &&
                                data.idSituacaoConvenio != 9
                            "
                        >
                            <!-- <i
                                class="fa fa-level-up fa-lg icon-button"
                                title="Integrar com RM"
                                @click.stop="confirmarIntegrarRM(data)"
                            ></i> -->
                        </span>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
        <router-view :convenio="convenio"></router-view>
    </div>
</template>

<script>
import ConveniosServicos from './ConveniosServicos'
import BtnConvenio from './cadastro/BtnConvenio.vue'

export default {
    components: {
        BtnConvenio
    },

    data() {
        return {
            convenios: [],
            convenio: null,
            campos: [
                {
                    key: 'vcCodigoEstruturado',
                    label: 'Convênio',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'convenente',
                    label: 'Convenente',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'vcObjeto',
                    label: 'Objeto',
                    filterable: true,
                    tdClass: 'colObjeto'
                },
                {
                    key: 'vigencia',
                    label: 'Vigência'
                },
                {
                    key: 'nuValorConvenio',
                    label: 'Total',
                    tdClass: 'text-right'
                },
                {
                    key: 'situacaoConvenio',
                    label: 'Situação',
                    filterable: true
                },
                {
                    key: 'descricaoStatusRM',
                    label: 'RM',
                    filterable: true
                },
                // {
                //     key: 'codConvenioRM',
                //     label: 'Id RM',
                //     filterable: true
                // },
                /*{
                    key: 'descricaoTipoAplicacaoRecurso',
                    label: 'Apl. Recurso',
                    filterable: true
                },*/
                {
                    key: 'acoes',
                    label: ''
                }
            ],
            itensPorPagina: 5
        }
    },

    methods: {
        detalharConvenio(id) {
            this.$router.push({
                name: 'Convenios_Detalhar',
                params: {
                    convenioId: id
                }
            })
        },

        editarConvenio(id) {
            this.$router.push({
                name: 'Convenio_Editar',
                params: {
                    convenioId: id
                }
            })
        },

        NovoConvenio() {
            this.$router.push({
                name: 'Convenio_Novo',
                params: {
                    convenioId: 0
                }
            })
        },

        obterConvenios() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterTodos().then((response) => {
                if (response) {
                    if (response.success) {
                        this.convenios = response.data
                    } else {
                        this.$toast.error(response.errors, 'ERROR', this.error)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmarEncerrarConvenio(obj) {
            this.$swal({
                title: 'Encerrar Convênio',
                html:
                    'Deseja Encerrar o Convênio <strong>' +
                    obj.vcCodigoEstruturado +
                    '</strong> ?',
                icon: 'success',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.encerrarConvenio(obj.idConvenio)
                }
            })
        },

        encerrarConvenio(id) {
            this.$store.dispatch('addRequest')
            ConveniosServicos.encerrarConvenio(id).then((response) => {
                if (response) {
                    if (response.success) {
                        this.obterConvenios()
                    } else {
                        this.$toast.error(response.errors, 'ERROR', this.error)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        toEmissaoDocumentos(conv) {
            this.convenio = conv
            this.$router.push({
                name: 'Convenios_EmissaoDocumentos',
                params: {
                    convenioId: this.convenio.idConvenio
                }
            })
        },

        confirmarIntegrarRM(obj) {
            this.$swal({
                title: 'Integrar RM',
                html:
                    'Deseja Integrar o Convênio <strong>' +
                    obj.vcCodigoEstruturado +
                    '</strong> com o RM ?',
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.IntegrarRM(obj.idConvenio)
                }
            })
        },

        IntegrarRM(id) {
            this.$store.dispatch('addRequest')
            ConveniosServicos.IntegrarConvenioRM(id).then((response) => {
                if (response) {
                    if (response.success) {
                        this.obterConvenios()
                    } else {
                        this.$toast.error(response.errors, 'ERROR', this.error)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {
        this.obterConvenios()
    },

    computed: {
        mostrarTabela() {
            return this.$route.name === 'Convenios'
        },

        permiteAcessoEmissaoDocumentos() {
            return this.$temAcessoView(['CONV-PAREC-FIN-00'])
        }
    },

    watch: {
        $route(to, from) {
            if (to.name === 'Convenios' || to.name === 'Convenios_Detalhar' || to.name === 'Convenio_Novo' || to.name === 'Convenio_Editar' ||
            from.name === 'Convenios' || from.name === 'Convenios_Detalhar' || from.name === 'Convenio_Novo' || from.name === 'Convenio_Editar' ) {
                    this.obterConvenios()
            }
        },
    }
}
</script>
